import {AppPermissions} from '@shared/constants/Mapping';
import useTicketingSystemPermission from '../../TicketingSystem/hooks/useTicketingSystemPermission';

type IClaimsTicketsPermission = typeof AppPermissions.CLAIMS_TICKETS;
interface IUsePriorAuthPermissionProps {
  objectFunction: Exclude<keyof IClaimsTicketsPermission, 'NAME'>;
}
const useClaimsTicketsPermissions = (
  props: IUsePriorAuthPermissionProps = {
    objectFunction: 'LIST'
  }
): boolean => {
  const {objectFunction} = props;
  return useTicketingSystemPermission({
    module: 'CLAIMS_TICKETS',
    objectFunction,
    groupPermission: 'CLAIMS_TICKETS_ENABLE'
  });
};

export default useClaimsTicketsPermissions;
